import * as React from "react";
const HomePeopleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
        <rect width={72} height={72} fill="#F8F5E9" rx={10} />
        <g clipPath="url(#a)">
            <path
                fill="#CEBDF1"
                stroke="#000"
                d="M37.62 47.055a8.343 8.343 0 0 1 16.655 0H37.62Z"
            />
            <circle
                cx={45.947}
                cy={36.503}
                r={3.921}
                fill="#fff"
                stroke="#000"
            />
            <path
                fill="#000"
                stroke="#000"
                d="M34.38 47.055H17.726a8.343 8.343 0 0 1 16.654 0Z"
            />
            <circle
                cx={26.053}
                cy={36.503}
                r={3.921}
                fill="#fff"
                stroke="#000"
            />
            <path
                fill="#0EAA15"
                stroke="#000"
                d="M27.673 52.581a8.343 8.343 0 0 1 16.655 0H27.673Z"
            />
            <circle cx={36} cy={42.029} r={3.921} fill="#fff" stroke="#000" />
            <path
                fill="#C9E9E9"
                stroke="#000"
                d="M30.762 19.419h12.367a2.5 2.5 0 0 1 2.5 2.5v4.15a2.5 2.5 0 0 1-2.5 2.5h-1.048a1.5 1.5 0 0 0-1.28.717l-.682 1.117a.5.5 0 0 1-.835.028l-.872-1.23a1.5 1.5 0 0 0-1.223-.632h-6.427a2.5 2.5 0 0 1-2.5-2.5v-4.15a2.5 2.5 0 0 1 2.5-2.5Z"
            />
            <circle cx={34.231} cy={23.925} r={0.801} fill="#000" />
            <circle cx={36.945} cy={23.925} r={0.801} fill="#000" />
            <circle cx={39.659} cy={23.925} r={0.801} fill="#000" />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M4 4h64v64H4z" />
            </clipPath>
        </defs>
    </svg>
);
export default HomePeopleIcon;
